(function () {
  if (window.__cxBg) return;
  window.__cxBg = true;
  function sample(img) {
    try {
      var w = 40;
      var h = Math.max(4, Math.round(w * img.naturalHeight / img.naturalWidth)) || 40;
      var c = document.createElement('canvas');
      c.width = w; c.height = h;
      var ctx = c.getContext('2d', { willReadFrequently: true });
      ctx.drawImage(img, 0, 0, w, h);
      var pts = [[1, 1], [w - 2, 1], [1, h - 2], [w - 2, h - 2], [Math.floor(w / 2), 1], [1, Math.floor(h / 2)], [w - 2, Math.floor(h / 2)]];
      var r = 0, g = 0, b = 0, n = 0;
      pts.forEach(function (p) {
        var d = ctx.getImageData(p[0], p[1], 1, 1).data;
        if (d[3] > 200) { r += d[0]; g += d[1]; b += d[2]; n++; }
      });
      if (!n) return;
      var box = img.closest('[data-cx-bg]');
      if (box) box.style.backgroundColor = 'rgb(' + Math.round(r / n) + ',' + Math.round(g / n) + ',' + Math.round(b / n) + ')';
    } catch (e) {}
  }
  function run() {
    document.querySelectorAll('[data-cx-bg] img.cx-pack').forEach(function (img) {
      if (img.complete && img.naturalWidth) sample(img);
      else img.addEventListener('load', function () { sample(img); }, { once: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
